import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronUp } from 'lucide-react';
import './ScrollToTop.css';

const ScrollToTop = ({ isHidden = false }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // Check if we're in miniapp mode
      const isMiniApp = window?.parent !== window || 
                        navigator.userAgent.includes('MiniApp') ||
                        window.location.search.includes('miniapp=true');
      
      // Don't show in miniapp mode
      if (isMiniApp) {
        setIsVisible(false);
        return;
      }
      
      // Check if any modal is open by looking for modal overlay elements
      const modalOverlays = document.querySelectorAll('[class*="modal-overlay"], [class*="modal-backdrop"], [class*="-modal-overlay"], [class*="-modal-backdrop"]');
      const isModalOpen = modalOverlays.length > 0;
      
      // Also check for RainbowKit modal
      const rainbowKitModal = document.querySelector('[data-rk]');
      const isRainbowKitModalOpen = rainbowKitModal && rainbowKitModal.querySelector('[role="dialog"]');
      
      if (window.pageYOffset > 400 && !isModalOpen && !isRainbowKitModalOpen && !isHidden) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    
    // Also listen for DOM changes to detect modal opening/closing
    const observer = new MutationObserver(toggleVisibility);
    observer.observe(document.body, { 
      childList: true, 
      subtree: true, 
      attributes: true, 
      attributeFilter: ['class'] 
    });

    // Check visibility on mount
    toggleVisibility();

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
      observer.disconnect();
    };
  }, [isHidden]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          className="scroll-to-top"
          onClick={scrollToTop}
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0 }}
          transition={{ duration: 0.3 }}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          aria-label="Scroll to top"
        >
          <ChevronUp size={24} />
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default ScrollToTop;